import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import Form, { ClientDescriptionFormMode } from "./Form";
import GenericDialog from "../GenericDialog";

const initialEntry = {
  clientDescriptionClients: [],
  descriptionName: "",
  provider: "",
  aiEngines: [],
  clientDescription: "",
  description: "",
  files: [],
  tags: [],
  dataset: "",
  engineFamily: {
    id: "1",
    text: "ChatGPT"
  },
  temperature: 0.0,
  isJson: false
};

export default function Create({ open, setOpen, onCreate }) {
  const { homeDispatch } = useContext(HomeAppContext);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [descriptionNeedsReviewed, setdescriptionNeedsReviewed] = useState(false);
  const [tagsFromApi, setTagsFromApi] = useState([]);
  const [familiesFromApi, setFamiliesFromApi] = useState([]);

  React.useEffect(() => {
    if (open) {
      setSubmitted(false);
      setErrors([]);
      setInternalEntry(initialEntry);
      setLoading(false);
      //setdescriptionNeedsReviewed(true);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
    setInternalEntry(initialEntry);
  };

  const handleReviewdescription = () => {
    const reviewDto = {
      clientDescriptionClients: internalEntry.clientDescriptionClients.map((e) => e.id),
      descriptionName: internalEntry.name,
      provider: internalEntry.provider,
      aiEngines: internalEntry.aiEngines.map((e) => e.id),
      clientDescription: internalEntry.clientDescription,
      description: internalEntry.description,
      tags: internalEntry.tags,
      temperature: internalEntry.temperature,
      isJson: internalEntry.isJson
    };
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Reviewing Client Description", loading: true }
    });
    api
      .post("/api/client-descriptions/review-clientDescription", reviewDto)
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Reviewing Client Description success",
            type: "success"
          }
        });
        setdescriptionNeedsReviewed(false);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };

  const handleCloseSave = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Saving Client Description", loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    const newdescription = {
      name: internalEntry.name,
      description: internalEntry.description,
      provider: internalEntry.provider,
      clientDescriptionClients: internalEntry.clientDescriptionClients.map((e) => e.id),
    };
    api
      .post(`/api/client-descriptions`, newdescription)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: internalEntry.name + ' saved!',
            type: "success"
          }
        });
        setOpen(false);
        setLoading(false);
        setInternalEntry(initialEntry);
        onCreate();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      {descriptionNeedsReviewed === true ? (
        <Button
          onClick={handleReviewdescription}
          variant="outlined"
          color="primary"
        >
          Review Client Description
        </Button>
      ) : (
        <Button
          onClick={handleCloseSave}
          color="primary"
          variant="outlined"
          autoFocus
          disabled={loading || saveDisabled}
        >
          Save Client Description
        </Button>
      )}
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      maxWidth={"lg"}
      open={open}
      onClose={handleClose}
      title={"New Client Description"}
      actions={actions}
    >
        <Form
          mode={ClientDescriptionFormMode.NEW}
          entity={internalEntry}
          tags={tagsFromApi}
          engineFamilies={familiesFromApi}
          errors={errors}
          setEntity={setInternalEntry}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
        />
    </GenericDialog>
  );
}
